import React, { Component } from "react";
import _  from 'lodash';
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

// UI Components
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";

import "../AdminDashboard.less";
import "./UsageReport.less";
import "./SessionList.less";

import { organisationAction } from "CONFIG/ActionFactory";

// Register the necessary components
ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend);

export default class DeviceAccessed extends Component{

  constructor(props){
    super(props);
    this.state={
      showSessionDetailsFlag: 1,
      selectedItem: 0,
      language: this.props.language,
      customerId: this.props.id,
      selectedYear: "",
      concurrentSessionReport: this.props.concurrentSessionReport,
      dropdownOpen: false,
    };
    this.handleYearChange = this.handleYearChange.bind(this);
  }

  componentDidUpdate(prevProps) {

    if (prevProps.concurrentSessionReport !== this.props.concurrentSessionReport) {
      this.setState({ concurrentSessionReport: this.props.concurrentSessionReport });
    }
  }

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  getFiscalYears = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const fiscalYears = [];

    let fiscalYearStart = currentMonth >= 3 ? currentYear : currentYear - 1;

    for (let i = 0; i < 5; i++) {
      const startYear = fiscalYearStart - i;
      const endYear = (startYear + 1).toString().slice(-2);
      fiscalYears.push(`${startYear}`);
    }

    return fiscalYears;
  };

  handleYearChange = (year) => {
    this.setState({ selectedYear: year });
    
    organisationAction.getCustomerConcurrentReportData(this.state.customerId, year)
    .then(
      response => {
        this.setState({ concurrentSessionReport: response?.data?.data?.concurrentSessionCount });
        console.log(this.state.concurrentSessionReport);
      }, error => {
        toastr.error(getMessage("CONCURRENT_REPORT_DATA_ERROR"));
        console.log(error);
      });
  }

  /**
    * Renders the usage report component, displaying device access and concurrent session graphs.
    * It retrieves data from the component's state and configures the chart options accordingly.
    * 
    * @returns {JSX.Element} The rendered component containing dropdown and graph elements.
    */
  render(){
    const fiscalYears = this.getFiscalYears();

    const monthLabels = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
    const zeroData = new Array(12).fill(0); // Array of 12 zeros

    const data = {
      labels: monthLabels,
      datasets: [
        {
          labels: '',
          data: zeroData, // All zeros
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgb(173, 216, 230)',
          borderWidth: 1,
        },
      ],
    };

    const options = {
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        y: {
          beginAtZero: true, 
          ticks: {
            stepSize: 1, 
            callback: function(value) {
              if (Math.floor(value) === value) {
                return value;
              }
            }
          },
          max: 2,
        }
      }
    };
    
    // Keep concurrent session data processing unchanged
    const concurrentRaw = this.state.concurrentSessionReport || {};
    const concurrentMaxValue = Math.max(...Object.values(concurrentRaw), 0);

    const concurrentData = {
      labels: Object.keys(concurrentRaw),
      datasets: [{
        label: '',
        data: Object.values(concurrentRaw),
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgb(255, 99, 132)',
        borderWidth: 1,
      }],
    };

    const concurrentOptions = {
      plugins: {
        legend: { display: false }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            callback: function(value) {
              if (Math.floor(value) === value) return value;
            }
          },
          max: concurrentMaxValue % 2 === 0 ? concurrentMaxValue + 2 : concurrentMaxValue + 1,
        }
      }
    };

    return(
      
      <div className="usageReportContainer">

        <div className="usageReportHeader">
          <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} className="customDropdown">
            <DropdownToggle caret>
              {this.state.selectedYear ? getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: this.state.selectedYear }) : getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: fiscalYears[0] })}
            </DropdownToggle>
            <DropdownMenu>
              {fiscalYears.map((year, index) => (
                <DropdownItem key={index} value={year} onClick={() => this.handleYearChange(year)}>
                  {getMessage("CUSTOMER_DATA_YEAR", { fiscalYear: year })}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="usageReportBody">
          <div className="usageReportGraphRow">
            
            <div className="usageReportGraphArea">
              <h5 className="centerAlign">{getMessage("COBROWSE_CONCURRENT_SESSIONS")}</h5>
              <Line data={concurrentData} options={concurrentOptions} />
            </div>
          </div>
        </div>

      </div>
        
    )

  }

}

